import { render, staticRenderFns } from "./TemplateStatuses.vue?vue&type=template&id=df7b6590&"
import script from "./TemplateStatuses.vue?vue&type=script&lang=js&"
export * from "./TemplateStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports